import Client from '@liquality/client'

import BitcoinSwapProvider from '@liquality/bitcoin-swap-provider'
import BitcoinLedgerProvider from '@liquality/bitcoin-ledger-provider'
import BitcoinJsWalletProvider from '@liquality/bitcoin-js-wallet-provider'
import BitcoinEsploraApiProvider from '@liquality/bitcoin-esplora-api-provider'
import BitcoinEsploraSwapFindProvider from '@liquality/bitcoin-esplora-swap-find-provider'

import EthereumRpcProvider from '@liquality/ethereum-rpc-provider'
import EthereumMetaMaskProvider from '@liquality/ethereum-metamask-provider'
import EthereumLedgerProvider from '@liquality/ethereum-ledger-provider'
import EthereumJsWalletProvider from '@liquality/ethereum-js-wallet-provider'
import EthereumSwapProvider from '@liquality/ethereum-swap-provider'
import EthereumErc20Provider from '@liquality/ethereum-erc20-provider'
import EthereumScraperSwapFindProvider from '@liquality/ethereum-scraper-swap-find-provider'

import { networks } from '@/utils/networks'
import { getDefaultRpcConfig } from '@/utils/rpc'

const CLIENT_CACHE = {}

const RpcProviders = {
  btc: BitcoinEsploraApiProvider,
  eth: EthereumRpcProvider
}

const JsWalletProviders = {
  btc: BitcoinJsWalletProvider,
  eth: EthereumJsWalletProvider
}

const SwapProviders = {
  btc: BitcoinSwapProvider,
  eth: EthereumSwapProvider
}

const LedgerProviders = {
  btc: BitcoinLedgerProvider,
  eth: EthereumLedgerProvider
}

const NetworkArgs = {
  btc: 'bitcoin_testnet',
  eth: 'rinkeby'
}

const SwapArgs = {
  btc: [{ network: networks.btc[NetworkArgs.btc] }, 'p2wsh'],
  eth: []
}

const AdditionalSwapProviders = {
  btc: BitcoinEsploraSwapFindProvider,
  eth: EthereumScraperSwapFindProvider
}

const AdditionalSwapArgs = {
  btc: getDefaultRpcConfig('btc', NetworkArgs.btc),
  eth: ['https://liquality.io/eth-rinkeby-api']
}

export const getSwapClient = (chain, mnemonic) => {
  const client = new Client()

  client.addProvider(new RpcProviders[chain](
    ...getDefaultRpcConfig(chain, NetworkArgs[chain])
  ))
  client.addProvider(new JsWalletProviders[chain](
    networks[chain][NetworkArgs[chain]],
    mnemonic
  ))
  client.addProvider(new SwapProviders[chain](
    ...SwapArgs[chain]
  ))
  client.addProvider(new AdditionalSwapProviders[chain](
    ...AdditionalSwapArgs[chain]
  ))

  return client
}

export const getClient = (chain, network, wallet, transport, addressType, erc20) => {
  wallet = wallet.toLowerCase()

  const key = chain + network + transport + wallet + addressType + erc20
  if (CLIENT_CACHE[key]) return CLIENT_CACHE[key]

  const client = new Client()
  client.addProvider(new RpcProviders[chain](...getDefaultRpcConfig(chain, network)))

  let walletProvider

  if (wallet.match(/metamask/)) {
    walletProvider = new EthereumMetaMaskProvider(window.web3.currentProvider, networks[chain][network])
  } else {
    const args = [{ network: networks[chain][network] }]

    if (chain === 'btc') {
      args.push(addressType)
    }

    walletProvider = new LedgerProviders[chain](...args)
  }

  if (transport === 'ble') walletProvider.useWebBle()
  client.addProvider(walletProvider)

  if (chain === 'eth') {
    if (erc20) {
      client.addProvider(new EthereumErc20Provider(erc20))
    }
  }

  CLIENT_CACHE[key] = client

  return CLIENT_CACHE[key]
}
